import { Log } from '@swivl-mono/types';
import { APIService } from '../Service/API.Service';
//LINK - apps/server/src/API/Debug/Debug.Controller.ts
export class DebugAPI {
  static async getDebug(): Promise<Log[]> {
    return APIService.Server.get<Log[]>('/debug/get-debug');
  }
  static async setDebug( debug: Log[]): Promise<void> {
     await APIService.Server.put('/debug/set-debug', { debug });
  }
}
